"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    height: ", ";\n    position: relative;\n    overflow: hidden;\n    background: ", ";\n"], ["\n    width: 100%;\n    height: ", ";\n    position: relative;\n    overflow: hidden;\n    background: ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n    top: 50%;\n    font-size: ", "em;\n    line-height: 0;\n    position: absolute;\n    transform: translateY(-50%);\n    color: ", ";\n    cursor: pointer;\n    z-index: 1;\n"], ["\n    top: 50%;\n    font-size: ", "em;\n    line-height: 0;\n    position: absolute;\n    transform: translateY(-50%);\n    color: ", ";\n    cursor: pointer;\n    z-index: 1;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n    left: 0;\n"], ["\n    left: 0;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n    right: 0;\n"], ["\n    right: 0;\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n    bottom: 0;\n    width: 100%;\n    position: absolute;\n    text-align: center;\n"], ["\n    bottom: 0;\n    width: 100%;\n    position: absolute;\n    text-align: center;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n    width: ", "em;\n    height: ", "em;\n    background: ", ";\n    border-radius: ", "em;\n    margin: ", "em;\n    display: inline-block;\n    cursor: pointer;\n"], ["\n    width: ", "em;\n    height: ", "em;\n    background: ", ";\n    border-radius: ", "em;\n    margin: ", "em;\n    display: inline-block;\n    cursor: pointer;\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n    overflow-x: hidden;\n"], ["\n    overflow-x: hidden;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _index = require("../../index");

var _reactCustomScrollbars = require("react-custom-scrollbars");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject, function (props) {
    return props.height;
}, function (props) {
    return props.theme.carousel.item.background;
});

var ArrowButton = _styledComponents2.default.a(_templateObject2, function (props) {
    return props.theme.carousel.arrows.size;
}, function (props) {
    return props.theme.carousel.arrows.color;
});

var ArrowButtonLeft = ArrowButton.extend(_templateObject3);

var ArrowButtonRight = ArrowButton.extend(_templateObject4);

var Dots = _styledComponents2.default.div(_templateObject5);

var Dot = _styledComponents2.default.a(_templateObject6, function (props) {
    return props.theme.carousel.dots.size;
}, function (props) {
    return props.theme.carousel.dots.size;
}, function (props) {
    return props.active ? props.theme.carousel.dots.activeBackground : props.theme.carousel.dots.background;
}, function (props) {
    return props.theme.carousel.dots.radius;
}, function (props) {
    return props.theme.carousel.dots.margin;
});

var StyledScrollbars = (0, _styledComponents2.default)(_reactCustomScrollbars.Scrollbars)(_templateObject7);

var Carousel = function (_React$Component) {
    _inherits(Carousel, _React$Component);

    function Carousel(props) {
        _classCallCheck(this, Carousel);

        var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this.state = {
            current: 0,
            direction: undefined,
            reset: false
        };
        return _this;
    }

    _createClass(Carousel, [{
        key: "prevItem",
        value: function prevItem(children) {
            var x;
            if (this.state.current) {
                x = this.state.current - 1;
            } else {
                x = children.length - 1;
            }
            this.setState({ current: x, direction: "left" });
        }
    }, {
        key: "nextItem",
        value: function nextItem(children) {
            var x;
            if (this.state.current != children.length - 1) {
                x = this.state.current + 1;
            } else {
                x = 0;
            }
            this.setState({ current: x, direction: "right" });
        }
    }, {
        key: "setCurrentItem",
        value: function setCurrentItem(x) {
            var direction = this.state.current > x ? "left" : "right";
            this.setState({
                current: x,
                direction: direction
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var children = this.props.children.filter(function (x) {
                console.log(x);
                return x != (undefined || null || false || "");
            });

            var childrenWithProps = _react2.default.Children.map(children, function (child, i) {
                return _react2.default.cloneElement(child, {
                    i: i,
                    current: _this2.state.current,
                    direction: _this2.state.direction,
                    first: Boolean(i == 0),
                    last: Boolean(i == _react2.default.Children.count(children) - 1)
                });
            });

            return _react2.default.createElement(
                Container,
                { height: this.props.height },
                _react2.default.createElement(
                    _reactCustomScrollbars.Scrollbars,
                    { autoHide: true },
                    childrenWithProps
                ),
                !this.props.hideControls && [_react2.default.createElement(
                    ArrowButtonLeft,
                    { onClick: function onClick() {
                            return _this2.prevItem(children);
                        } },
                    _react2.default.createElement(_index.Icon, {
                        name: this.props.theme.carousel.arrows.leftIcon
                    })
                ), _react2.default.createElement(
                    ArrowButtonRight,
                    { onClick: function onClick() {
                            return _this2.nextItem(children);
                        } },
                    _react2.default.createElement(_index.Icon, {
                        name: this.props.theme.carousel.arrows.rightIcon
                    })
                ), _react2.default.createElement(
                    Dots,
                    null,
                    _react2.default.Children.map(children, function (child, i) {
                        return _react2.default.createElement(Dot, {
                            onClick: function onClick() {
                                return _this2.setCurrentItem(i);
                            },
                            active: _this2.state.current == i
                        });
                    })
                )]
            );
        }
    }]);

    return Carousel;
}(_react2.default.Component);

Carousel = (0, _styledComponents.withTheme)(Carousel);

Carousel.displayName = "Carousel";

Carousel.propTypes = {
    hideControls: _propTypes2.default.bool,
    height: _propTypes2.default.string
};

Carousel.defaultProps = {
    hideControls: false,
    height: "100%"
};

exports.default = Carousel;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/carousel/carousel.js
// module id = 450
// module chunks = 95715928098905 168707334958949